module.exports = __webpack_public_path__ + "static/media/spinner.07d32264.svg";